import { render, staticRenderFns } from "./MPstats.vue?vue&type=template&id=1ffb3912&scoped=true&"
import script from "./MPstats.vue?vue&type=script&lang=js&"
export * from "./MPstats.vue?vue&type=script&lang=js&"
import style0 from "./MPstats.vue?vue&type=style&index=0&id=1ffb3912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb3912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffb3912')) {
      api.createRecord('1ffb3912', component.options)
    } else {
      api.reload('1ffb3912', component.options)
    }
    module.hot.accept("./MPstats.vue?vue&type=template&id=1ffb3912&scoped=true&", function () {
      api.rerender('1ffb3912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/components/MarketPlace/MPstats.vue"
export default component.exports